let getters = {
    isAccountInList(state) {
        return new_account_nbr =>
            state.user_accounts.map(function (s) {
                if (s.account_nbr) return s.account_nbr;
            }).indexOf(parseInt(new_account_nbr)) !== -1;
    },
    hasAccountRole: state => (account_nbr, role_cd) => {
        if (state.visible_user.is_sys_admin == 1) {
            return true;
        }

        return state.user_accounts.filter(account => account.account_nbr == account_nbr && _.has(account, ['rolesArray', role_cd])).length > 0;
    },
    hasRole: (state) => (rolesArray) => {
        if (state.visible_user.is_sys_admin == 1) {
            return true
        }
        for (var i = 0; i < rolesArray.length; i++) {
            if (state.visible_user.approved_roles) {
                if (state.visible_user.approved_roles.includes(rolesArray[i])) {
                    return true
                }
            }
        }
        return false
    },

    hasStatus: (state) => (statusArray) => {
        if (statusArray.indexOf(state.visible_user.status_cd) > -1 ) {
            return true;
        }
    },


    hasIndustry: (state) => (industryArray) => {
        if (state.visible_user.is_sys_admin == 1) {
          return true;
        }
        return state.user_accounts.some (function (user_account)  {
          return industryArray.indexOf(user_account.account.default_industry_id) > -1;
        });

    },

    hasPhone: (state) => () => state.visible_user.phone1 != ""
};

export default getters;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/user/getters.js